import React from "react";
//#region types
import { BulletListProps } from "models/propTypes/listPropTypes";
//#endregion
//#region components
import { Grid, List, ListItem, ListItemIcon, ListItemText } from "@mui/material";
import Icon from "../icon";
//#endregion
import cssExports from "theme/styles/main.module.scss";

const BulletList: React.FC<BulletListProps> = (props) => {
  return (
    <React.Fragment>
      {props.items && props.items.length > 0 ? (
        <Grid container>
          <List className={cssExports.bulletList}>
            {props.items.map((rowItem, index) => {
              return (
                <ListItem className={cssExports.bulletListItem}>
                  <ListItemIcon className={cssExports.bulletListIcon} key={index}>
                    <Icon icon={props.icon} />
                  </ListItemIcon>
                  <ListItemText primary={rowItem} className={cssExports.bulletListText} />
                </ListItem>
              );
            })}
          </List>
        </Grid>
      ) : (
        <React.Fragment />
      )}
    </React.Fragment>
  );
};

export default BulletList;
